import classNames from 'classnames';
import React from 'react';
import useDeviceDetect from 'Hooks/useDeviceDetect';
import { Breadcrumbs, BreadcrumbItem } from 'Views/Components/New/Breadcrumbs';

interface Props {
	title?: string | React.ReactNode;
	subtitle?: string | React.ReactNode;
	breadcrumbs?: BreadcrumbItem[];
	actions?: React.ReactNode;
	children?: React.ReactNode;
	className?: string;
}

export default function CrudHeader({ title, subtitle, breadcrumbs, actions, children, className }: Props) {
	const { isMobile } = useDeviceDetect();

	const containerClasses = classNames(
		'mx-auto flex w-full px-8 py-4 gap-4 transition-all duration-300 max-w-full',
		isMobile ? 'flex-col items-start' : 'flex-row flex-wrap items-center justify-between',
		className,
	);

	return (
		<header className="sticky top-0 z-20 w-full bg-white border-b border-gray-200">
			<div className={containerClasses}>
				<div className="flex flex-col flex-1 min-w-0">
					{breadcrumbs && <Breadcrumbs items={breadcrumbs} className="mb-1" />}
					{title && <h1 className="font-sans text-2xl font-bold text-gray-900">{title}</h1>}
					{subtitle && <p className="!mb-0 mt-1 text-sm text-gray-400 font-sans">{subtitle}</p>}
					{children}
				</div>

				{actions && (
					<div className="flex flex-row flex-wrap items-center justify-end gap-3 shrink-0">{actions}</div>
				)}
			</div>
		</header>
	);
}

CrudHeader.Left = ({ children }: { children: React.ReactNode }) => <div className="flex-1 min-w-0">{children}</div>;

CrudHeader.Right = ({ children }: { children: React.ReactNode }) => (
	<div className="flex flex-row flex-wrap items-center gap-3 shrink-0">{children}</div>
);
